<template>
  <transition
    name="fade"
    appear
  >
    <div
      v-if="innerShow"
      :id="id"
      ref="modal"
      class="modal fade"
      :class="{'show': innerShow}"
      :style="{'display': innerShow? 'block': ''}"
      data-backdrop="static"
      tabindex="-1"
      role="dialog"
    >
      <!-- <template>
      <span v-hotkey="keymap"></span>
    </template> -->
      <div
        class="modal-dialog modal-dialog-centered"
        :class="dialogClasses"
        role="document"
      >
        <div
          class="modal-content"
          :class="modalAlert ? 'modal-alert' : ''"
        >
          <div
            v-if="title"
            class="modal-header d-flex align-items-center"
          >
            <base-heading :class="`${!showCloseButton ? 'mr-auto' : ' my-1'}`" class="header-title">
              <slot
                name="header"
                :title="title"
              >
                {{ title }}
              </slot>
            </base-heading>
            <div>
              <button
                v-if="showCloseButton"
                type="button"
                class="close"
                aria-label="Close"
                @click="close()"
              >
                <base-icon icon="x-24" />
              </button>
            </div>
          </div>
          <button
            v-if="!title && showCloseButton"
            type="button"
            class="close position-absolute"
            style="right: 32px; top: 25px; z-index: 9999;"
            data-dismiss="modal"
            aria-label="Close"
            @click="close()"
          >
            <base-icon icon="x-24" />
          </button>
          <div
            class="modal-body"
            :class="bodyClasses"
          >
            <slot>Content Here</slot>
          </div>
          <div
            v-if="hasFooter()"
            class="modal-footer"
            :class="{'modal-footer--expanded': expanded}"
          >
            <slot name="footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import { EventBus } from '@/_utilities/eventBus';

export default {
  name: 'BaseModal',
  props: {
    id: {
      type: String,
      default: '',
      required: false,
    },
    title: {
      type: String,
      default: '',
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
    modalAlert: {
      type: Boolean,
      default: false,
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    /**
     * The size of the modal
     * modal-sm = 300px | modal-md = 500 max | modal-lg= 800px | modal-xl = 1024px
     * @values modal-xl, modal-md
     */
    size: {
      type: String,
      default: 'modal-lg',
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    /**
     * Paddings medium size (30px)
     */
    paddingMd: {
      type: Boolean,
      default: false,
    },
    /**
     * This prop will center the modal vertically - 40px to match figma
     */
    centered: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      innerShow: false,
    };
  },
  computed: {
    dialogClasses() {
      const classes = [this.size];

      if (this.centered) {
        classes.push('modal--centered');
      }
      return classes;
    },
    bodyClasses() {
      return {
        'modal-body--expanded': this.expanded,
        'modal-body--padding-md': this.paddingMd,
      };
    },
    keymap() {
      return {
        esc: this.close,
      };
    },
  },
  watch: {
    innerShow(value) {
      if (value) {
        document.querySelector('body').classList.add('modal-open');
      } else {
        document.querySelector('body').classList.remove('modal-open');
      }
    },
    show: {
      handler() {
        if (this.show === true) {
          this.showModal();
        } else {
          this.innerShow = false;
        }
      },
      immediate: true,
    },
  },
  mounted() {
    // Move tooltip outside component
    document.body.appendChild(this.$el);

    // Close modal before opening a new one
    EventBus.$on('modal-open', () => {
      this.innerShow = false;
    });

    if (this.show === true) {
      this.showModal();
    }
  },
  beforeDestroy() {
    /*
    This removes the bad scroll behavior if the modal component is destroyed before is closed
    Prefers :show over v-if
    */
    document.querySelector('body').classList.remove('modal-open');
  },
  destroyed() {
    /**
     * This hides any element relative to the modal
    */
    if (this.$el) {
      this.$el.remove();
    }
  },
  methods: {
    hasFooter() {
      if (!this.$slots.footer) {
        return false;
      }

      return this.showFooter;
    },
    close() {
      this.innerShow = false;
      this.$emit('closed');
    },
    showModal() {
      EventBus.$emit('modal-open');
      this.$nextTick().then(() => {
        this.innerShow = true;
        this.$emit('shown');
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.close {
  opacity: 1;
  padding: unset;
  margin: unset !important;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.modal{
  background-color: rgba(black, 0.5);
  z-index: $zindex-modal;
}
.modal-detail{
  max-width: 1200px !important;
}
.modal-full {
  max-width: calc(100vw - 2rem) !important;
}
.modal-xl {
  max-width: 1024px!important;
}
.modal-lg {
  max-width: 800px!important;
}
.modal-md {
  width: 502px!important;
  top: -8%;

  .close {
    img{
      width: 13px;
      height: 13px;
      margin-bottom: 7px;
    }
  }
}
.modal-header {
  // background-color: $gray-light;
  // border: none !important;
}
.modal-body--expanded {
  padding: 3.125rem;
  padding-bottom: 0;
}
.modal-body--padding-md {
  padding: 1.875rem;
  padding-bottom: 0;
}
.modal-footer--expanded {
  padding: 3.125rem;
  padding-bottom: 24px;
  padding-top: 1rem;
}
.modal--centered {
  top: calc(50% - 40px);
  transform: translateY(-50%) !important;
}
.modal-dialog {
  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out, max-width 0.2s !important;
}
.modal-alert {
  padding: unset !important;
  .modal-body{
    padding: unset !important;
    //  heading
    ::v-deep .base-heading{
      line-height: 22.8px;
      letter-spacing: 0.01rem;
      margin-bottom: 24px !important;
      padding: 24.5px 0px 24.5px 24px !important;
      margin: unset !important;
    }
    //  hr
    ::v-deep hr{
      // width: 100px;
      margin: unset !important;
    }
  }
    ::v-deep .base-select{
      margin: 0px 24px 24px 24px;
    }
  // button close x
    ::v-deep .close{
      margin-right: unset !important;
      margin-top: unset !important;
    }
    ::v-deep .modal-footer{
      padding: 16px 24px 24px 24px;
      .base-button {
        font-family: 'SilkaLight';
        padding: 10px 12px;
        height: 36px;
        border: 1px solid #D6D6D6 !important;
        margin-right: unset !important;
        font-size: 14px;

        &--inverse {
          border: none !important;
          padding: 8.5px 16px !important;
          font-size: 14px;
          margin-left: 12px !important;
        }
      }
    }
}

@media (max-width: map-get($breakpoints,'lg')) {
  .modal-lg {
    max-width: 728px !important;
    margin: 9px;
  }
}
.header-title{
  font-family: 'Tiempos Headline';
  font-style: normal;
  font-weight: 600;
  font-size: 19px;
  line-height: 120%;
  letter-spacing: 0.01em;
  color: #1B1B1B;
}
</style>
